import { createFeature, createReducer, on } from '@ngrx/store';
import { ToastActions } from './toast.actions';

export interface ToastMessage {
  severity: string;
  summary: string;
  detail: string;
  id: number;
}

export interface ToastState {
  messages: ToastMessage[];
}

const initialState: ToastState = {
  messages: [],
};

let messageId = 0;

export const toastFeature = createFeature({
  name: 'toast',
  reducer: createReducer(
    initialState,
    on(ToastActions.showToast, (state, { severity, summary, detail }) => ({
      ...state,
      messages: [...state.messages, { severity, summary, detail, id: ++messageId }],
    })),
    on(ToastActions.clearToast, (state) => ({
      ...state,
      messages: [],
    })),
  ),
});

export const { selectToastState, selectMessages } = toastFeature;
